// components/TypingAnimation.jsx
import { useEffect, useState } from 'react';

const texts = ["Clarissa Vega", "Software Developer"];

export default function TypingAnimation() {
  const [text, setText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const speed = 150;
    const timeout = setTimeout(() => {
      if (!isDeleting) {
        if (text.length < texts[currentIndex].length) {
          setText(texts[currentIndex].substring(0, text.length + 1));
        } else {
          setTimeout(() => setIsDeleting(true), 1000);
        }
      } else {
        if (text.length > 0) {
          setText(text.substring(0, text.length - 1));
        } else {
          setIsDeleting(false);
          setCurrentIndex((currentIndex + 1) % texts.length);
        }
      }
    }, speed);

    return () => clearTimeout(timeout);
  }, [text, currentIndex, isDeleting]);

  return (
    <span className="inline-flex items-center font-bold whitespace-nowrap">
      <span>{text}</span>
      <span className="inline-block w-1 h-6 bg-black animate-pulse ml-1 align-middle"></span>
    </span>
  );
}
